// 32ecc37db61fa70464333dd9db4b756d8a985b28|className=AreaMeasurementUnitApi|type=angular|apiName=am|apiEnumKey=AM|operationHash=d6101950c2fcb9d6480ca7c35a205bd35c76ce94|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseAreaMeasurementUnitFromJSON } from '../../../parsers/AreaMeasurementUnit';

export class AreaMeasurementUnitApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @description <p>🔐 Auth</p>
   *
   * @tags AreaMeasurementUnitApi
   * @name AreaMeasurementUnitApiGetAllAreaMeasurementUnits
   * @request GET:/measurements
   * @secure
   */
  getAllAreaMeasurementUnits(
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/measurements`,
        method: 'GET',
        api: Api.AM,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseAreaMeasurementUnitFromJSON,
    isContentArray: true,
  }),
      },
    );
  }

  static ɵfac = function AreaMeasurementUnitApi_Factory(t) { return new (t || AreaMeasurementUnitApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: AreaMeasurementUnitApi, factory: AreaMeasurementUnitApi.ɵfac, providedIn: 'root' });
}
